export default __webpack_public_path__ + "material-symbols-outlined.woff2";